import {
  RECEIVE_ALL_DATA,
  RECEIVE_CONVERT_RATE,
  RECEIVE_MORE_SINGLE_DATA,
  RECEIVE_SINGLE_DATA,
  REQUEST_ALL_DATA,
  REQUEST_SINGLE_DATA,
  SET_CURRENT_PRODUCT,
} from '../actions/DataPageActionCreators';

const defaultState = {
  isFetching: false,
  allProducts: [],
  prices: {},
  convertRates: {},
};

export function dataPage(state = defaultState, action = null) {
  switch (action.type) {
    case RECEIVE_ALL_DATA: {
      return Object.assign({}, state, {
        allProducts: Object.assign({}, state.allProducts, action.data.data),
        lastUpdated: action.receivedAt,
      });
    }

    case RECEIVE_SINGLE_DATA: {
      return Object.assign({}, state, {
        prices: Object.assign({}, state.prices, {
          [action.id]: Object.assign({}, action.data, {
            from: action.from,
            size: action.size,
          }),
        }),
      });
    }

    case RECEIVE_MORE_SINGLE_DATA: {
      return Object.assign({}, state, {
        prices: Object.assign({}, state.prices, {
          [action.id]: Object.assign({}, state.prices[action.id], {
            paging: action.data.paging,
            from: action.from,
            size: action.size,
            data: Object.assign(
              {},
              action.data.data.concat(state.prices[action.id].data)
            ),
          }),
        }),
      });
    }

    case RECEIVE_CONVERT_RATE: {
      return Object.assign({}, state, {
        convertRates: action.data,
      });
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/dataPage.js